import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { usePageVisibility } from "../../../hooks/usePageVisibility";
import { globalStateSelector } from "../../../redux/globalState/globalStateSlice";
import { getMessageSelector } from "../../../redux/message/messageSlice";
import { AppDispatch } from "../../../redux/store";
import {
  canUseClubImportSelector,
  fetchUserNotifications,
  getUserSelector,
  userIsPaidSelector,
} from "../../../redux/user/userSlice";
import { AllowTrackingPopup } from "../../features/Extension/AllowTrackingPopup";
import { Notifications } from "../Notifications/Notifications";

type Props = {
  children: React.ReactNode;
  isLoggedIn: boolean;
};

const AppWrapper = ({ children, isLoggedIn }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { userNotifications, user } = useSelector(getUserSelector);
  const { isCurrentlyImporting } = useSelector(globalStateSelector);
  const { alerts } = useSelector(getMessageSelector);
  const canUseClubImport = useSelector(canUseClubImportSelector);
  const userIsPaid = useSelector(userIsPaidSelector);
  const userPaid = userIsPaid || localStorage.getItem("paid") === "true";
  const location = useLocation();

  useEffect(() => {
    const disabledAds =
      userPaid ||
      [
        "/get-my-players",
        "/get-my-evolutions",
        "/get-sbc-solver",
        "/subscription",
        "/login",
        "/profile",
        "/meta-rating",
      ].includes(location.pathname);

    if (disabledAds) {
      document.body.classList.add("paying-user");
    } else {
      document.body.classList.remove("paying-user");
    }
    return () => {
      document.body.classList.remove("paying-user");
    };
  }, [location.pathname, userPaid]);

  const handleVisibilityChange = useCallback(
    (visible: boolean) => {
      const blockedPages = ["import"];
      if (
        isLoggedIn &&
        visible &&
        !blockedPages.includes(window.location.pathname) &&
        !isCurrentlyImporting
      ) {
        dispatch(fetchUserNotifications());
      }
    },
    [isLoggedIn, dispatch, isCurrentlyImporting],
  );

  usePageVisibility(handleVisibilityChange);

  return (
    <div className="min-h-screen">
      {children}
      {(userNotifications.length > 0 || alerts.length > 0) && (
        <Notifications userNotifications={userNotifications} alerts={alerts} />
      )}
      {/* {canUseClubImport && user.allowTracking === undefined && (
        <AllowTrackingPopup />
      )} */}
    </div>
  );
};

export default AppWrapper;
